import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { HighlightOffOutlined } from "@material-ui/icons";
import Paper from "@material-ui/core/Paper";
import TitleBar from "../Layout/titleBar";
import Pagination from "../Layout/pagination";
import ItemPedido from "./itemPedido";
import BusquedaAvanzadaModal from "./busquedaAvanzadaModal";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import "./styles.css";
import NumberFormat from "react-number-format";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

const styles = () => ({
  rootDialog: {
    zIndex: 1250,
  },
  rootInfo: {
    zIndex: 1200,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "-5px 4px 10px #8E8E8E29",
    borderRadius: "21px",
    opacity: 1,
    padding: "0px !important",
    minWidth: "300px",
  },
});

class Pedidos extends React.Component {
  renderSearchBar = () => {
    return (
      <Row className="searchBar">
        <Col xs={12} sm={3}>
          <TextField
            className="filterInput"
            select
            value={this.props.filtros.idFormaEntrega}
            name="idFormaEntrega"
            onChange={this.props.handleOnFiltroChange}
          >
            <MenuItem key={0} value={0}>
              {"Todos"}
            </MenuItem>

            {this.props.formasEntrega.map((e) => (
              <MenuItem key={e.idFormaEntrega} value={e.idFormaEntrega}>
                {e.descripcion}
              </MenuItem>
            ))}
          </TextField>
        </Col>
        <Col xs={1}>&nbsp;</Col>
        <Col xs={12} sm={4}>
          <TextField
            className="filterInput"
            select
            value={this.props.filtros.idEstadoPedido}
            name="idEstadoPedido"
            onChange={this.props.handleOnFiltroChange}
          >
            <MenuItem key={0} value={0}>
              {"Todos los estados"}
            </MenuItem>

            {this.props.estadosPedido.map((e) => (
              <MenuItem key={e.idEstadoPedido} value={e.idEstadoPedido}>
                {e.descripcion}
              </MenuItem>
            ))}
          </TextField>
        </Col>
        <Col xs={1}>&nbsp;</Col>
        {
          <Col xs={12} sm={2}>
            <TextField
              className="filterInput"
              value={this.props.filtros.numeroPedido}
              name="numeroPedido"
              InputProps={{
                placeholder: "Nro. pedido",
                endAdornment: (
                  <InputAdornment position="end">
                    {this.props.filtros.numeroPedido &&
                      this.props.filtros.numeroPedido.length > 0 && (
                        <HighlightOffOutlined
                          onClick={() => this.props.handleOnLimpiarFiltro("numeroPedido")}
                        />
                      )}
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[0-9]*$/.test(value)) {
                  this.props.handleOnFiltroChange(e);
                }
              }}
            />
          </Col>
        }
        <Col xs={1}>&nbsp;</Col>
      </Row>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <div className="pedidos">
        {/* menú superior */}
        <TitleBar
          title={`Pedidos ${this.props.nombreCatalogo ? " de " + this.props.nombreCatalogo : ""}`}
          searchBar={this.renderSearchBar()}
          handleOnSearch={() => this.props.handleOnFiltrar(true)}
          handleOnSearchAdvanced={this.props.handleOnOpenModalAvanzada}
        />

        {this.props.ultimoItemActualizado && this.props.ultimoItemActualizado.value && (
          <div
            className={`fechaUltimoItem ${this.props.ultimoItemActualizado.resaltar === true ? "fechaUltimoItemRojo" : ""}`}
          >
            {this.props.ultimoItemActualizado.value}
          </div>
        )}

        {/* contenido */}

        <Paper className="pedidosContainer">
          {/* ITEMS */}
          <Row>
            {this.props.pedidos.result.map((p) => (
              <Col xs={12} md={6} lg={6} xl={4} style={{ padding: "5px" }} key={p.id}>
                <ItemPedido key={p.id} item={p} />
              </Col>
            ))}
          </Row>

          {/* PAGINACION */}
          <Pagination
            handleOnChange={this.props.handleOnPagination}
            page={this.props.pedidos.currentPage + 1 || 0}
            totalPages={this.props.pedidos.totalObjects !== 0 ? this.props.pedidos.totalPages : 0}
          />
        </Paper>

        {/* MODAL BUSQUEDA AVANZADA */}

        <BusquedaAvanzadaModal
          open={this.props.openModal}
          handleOnVolver={this.props.handleOnVolver}
          handleOnBuscarAvanzada={this.props.handleOnFiltrar}
          handleOnFiltroChange={this.props.handleOnFiltroChange}
          estadosPedido={this.props.estadosPedido}
          filtros={this.props.filtros}
          handleFechaDesde={this.props.handleFechaDesde}
          handleFechaHasta={this.props.handleFechaHasta}
          handleNombreArticulo={this.props.handleNombreArticulo}
          handleCodigoArticulo={this.props.handleCodigoArticulo}
          handleIdEstadoPedido={this.props.handleIdEstadoPedido}
          handleNroPedido={this.props.handleNroPedido}
          handleOnChangeFiltroImporte={this.props.handleOnChangeFiltroImporte}
          handleRazonSocial={this.props.handleRazonSocial}
        />

        {/* INFO USUARIO */}
        <Dialog
          classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootInfo }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          open={this.props.pedidoInfoUsuario !== undefined}
          fullWidth={true}
        >
          <DialogContent classes={{ root: classes.rootInfo }}>
            <Row style={{ margin: "0px" }}>
              <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                <div className="containerModalQuitar">
                  <div className="labelTitleDatosUsuario">Datos de usuario</div>

                  <div className="campoInfo" style={{ marginTop: "22px" }}>
                    <div className="infoClave">Nombre y apellido</div>
                    <div className="infoValue">
                      {this.props.pedidoInfoUsuario
                        ? this.props.pedidoInfoUsuario.razonSocial
                        : "Sin Nombre y apellido"}
                    </div>
                  </div>

                  <div className="campoInfo" style={{ marginTop: "10px" }}>
                    <div className="infoClave">DNI</div>
                    {this.props.pedidoInfoUsuario && this.props.pedidoInfoUsuario.dni ? (
                      <NumberFormat
                        className="infoValueDni"
                        customInput={TextField}
                        inputProps={{
                          className: "infoValue",
                          style: { marginTop: "-5px", marginBlockEnd: "-5px" },
                        }}
                        background="white"
                        name="dni"
                        value={this.props.pedidoInfoUsuario.dni}
                        decimalScale={0}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        decimalSeparator={false}
                        thousandSeparator={"."}
                        isAllowed={({ value }) => value <= 99999999}
                      />
                    ) : (
                      <div className="infoValue">Sin DNI</div>
                    )}
                  </div>

                  <div className="campoInfo" style={{ marginTop: "8px" }}>
                    <div className="infoClave">Email</div>
                    <div className="infoValue">
                      {this.props.pedidoInfoUsuario
                        ? this.props.pedidoInfoUsuario.correo
                        : "Sin Email"}
                    </div>
                  </div>

                  <div className="campoInfo" style={{ marginTop: "8px" }}>
                    <div className="infoClave">Teléfono:</div>
                    <div className="infoValue">
                      {this.props.pedidoInfoUsuario ? this.props.pedidoInfoUsuario.telefono : ""}
                    </div>
                  </div>

                  <div className="campoInfo" style={{ marginTop: "8px" }}>
                    <div className="infoClave">Direcciones</div>
                    {this.props.pedidoInfoUsuario ? (
                      this.props.pedidoInfoUsuario.listaDomicilios ? (
                        this.props.pedidoInfoUsuario.listaDomicilios.map((domicilio) => (
                          <div
                            key={domicilio.idDomicilioEntrega}
                            className="infoValue"
                            style={{
                              paddingLeft:
                                domicilio.idDomicilioEntrega ===
                                  this.props.pedidoInfoUsuario.idDomicilioEntrega &&
                                this.props.pedidoInfoUsuario.descripcionFormaEntrega === "DELIVERY"
                                  ? "0px"
                                  : "30px",
                            }}
                          >
                            <div>
                              {" "}
                              {domicilio.idDomicilioEntrega ===
                                this.props.pedidoInfoUsuario.idDomicilioEntrega &&
                                this.props.pedidoInfoUsuario.descripcionFormaEntrega ===
                                  "DELIVERY" && (
                                  <ShoppingCartOutlinedIcon className="shoppingCart" />
                                )}{" "}
                              {domicilio.domicilio}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="infoValue2">Sin Direcciones</div>
                      )
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="containerBtnCerrar">
                    <Button className="btnCerrar" onClick={() => this.props.handleOnClickBtnInfo()}>
                      CERRAR
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

Pedidos.propTypes = {
  pedidos: PropTypes.object.isRequired,
  estadosPedido: PropTypes.array.isRequired,
  formasEntrega: PropTypes.array.isRequired,
  filtros: PropTypes.object,
  handleOnFiltroChange: PropTypes.func,
  handleOnLimpiarFiltro: PropTypes.func,
  handleOnFiltrar: PropTypes.func,
  handleOnPagination: PropTypes.func,
  handleOnClickInfoUsuario: PropTypes.func,
  //
  handleOnOpenModalAvanzada: PropTypes.func,
  handleOnVolver: PropTypes.func,
  handleOnBuscarAvanzada: PropTypes.func,
  openModal: PropTypes.object.isRequired,

  handleFechaDesde: PropTypes.func,
  handleFechaHasta: PropTypes.func,
  handleNombreArticulo: PropTypes.func,
  handleCodigoArticulo: PropTypes.func,
  handleIdEstadoPedido: PropTypes.func,
  handleNroPedido: PropTypes.func,
  handleOnChangeFiltroImporte: PropTypes.func,
  handleRazonSocial: PropTypes.func,
  ultimoItemActualizado: PropTypes.object,
};

Pedidos.defaultProps = {
  pedidos: { result: [] },
  estadosPedido: [],
  formasEntrega: [],
};

export default withStyles(styles)(Pedidos);
